import httpClient from './http-client';

const endpoint = 'api/patient-story';

const patientStoryService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (patientStory) => httpClient.post(`${endpoint}`, patientStory),

  update: (patientStory) => httpClient.put(`${endpoint}/${patientStory.id}`, patientStory),

  delete: (patientStory) => httpClient.delete(`${endpoint}/${patientStory.id}`),
};

export default patientStoryService;
